import React, { useState, useEffect } from "react";
import { axiosapi } from "../api/axiosapi";
import { BsArrowLeftRight } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { MdLocationPin } from "react-icons/md";
import "react-day-picker/dist/style.css";
import { Calendar } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { format } from "date-fns";
import YOURTRIPLOGO from '../images/ticketiconhome.svg';
import GLOBALLOGO from '../images/globalcoverage.svg';
import SUPPORTLOGO from '../images/support.svg';

import HEROIMG from "../images/busbudhero.PNG";
import TravelBloggerHome from "../Components/TravelBloggerHome";
import TopTravelledRoutesComponent from "../Components/TopTravelledRoutesComponent";


const HomePage = (props) => {
  const navigate = useNavigate();
  const [showoriginmenu, setshoworiginmenu] = useState(false);
  const [showdestinationmenu, setshowdestinationmenu] = useState(false);
  const [cities, setcities] = useState([]);
  const [origin, setorigin] = useState("");
  const [destination, setdestination] = useState("");
  const [error, setError] = useState('');

  const [date, setdate] = useState(new Date());
  const [showcalendar, setshowcalendar] = useState(false);
  useEffect(() => {
    setError('')
  }, [origin, destination]);
  const compareDate = (date) => {
    const otherDate = new Date(date);
    const currentDate = new Date();
    otherDate.setHours(0, 0, 0, 0)
    currentDate.setHours(0, 0, 0, 0)
    if (currentDate > otherDate) {

      return false
    }
    else {

      return true
    }
  }

  useEffect(() => {
    const fetchcities = async () => {
      try {
        const response = await axiosapi.get("/city");
        setcities(response.data.city);

      }
      catch (error) {
        setError("Some error occured while fetching cities");
      }

    };
    fetchcities();
  }, []);
  const toggleOriginandDest = () => {
    if (origin && destination) {
      let x;
      x = origin;
      setorigin(destination);
      setdestination(x);
    }
  }
  const handleQueryChange = (e) => {
    setshoworiginmenu(true);
    const newquery = e.target.value.toLowerCase();
    setorigin(newquery);
  };
  const handleQuerytwoChange = (e) => {
    setshowdestinationmenu(true);
    const newquery = e.target.value.toLowerCase();
    setdestination(newquery);
  };
  const filteredCities = cities.filter((city) =>
    city.City.toLowerCase().startsWith(origin)
  );
  const filteredtwoCities = cities.filter((city) =>
    city.City.toLowerCase().startsWith(destination)
  );
  const handleShowOrigin = (city) => {
    setorigin(city);
    setshoworiginmenu(false);
  };
  const handleShowDestination = (city) => {
    setdestination(city);
    setshowdestinationmenu(false);
  };

  const handleCalendarSelect = (date) => {
    setdate(date);
    setshowcalendar(false);
  };

  const handleSearchButton = async () => {
    if (origin === '' || destination === '') {
      setError('Origin or Destination cannot be empty')
    }
    else {
      let x = date.getDay();
      let compDateBoolean = compareDate(date);

      if (!compDateBoolean) {
        setError("You have selected past date")
      }
      else {
        const response = await axiosapi.post("/bus/bussearch", {
          origin: origin.trim(),
          destination: destination.trim(),
          journeyDate: date,
          journeyDay: x,
        });
        if (!response.data.success) {
          setError(response.message)

        }
        else {
          console.log(response.data.bus)
          props.addBus(response.data.bus);
          props.addJourneyDetails(origin, destination, date);
          const responses = await axiosapi.post("/booking/findbyroute", {
            origin: origin.trim(),
            destination: destination.trim(),
            journeyDate: date
          });

          props.fetchBookingByRoute(responses.data.booking);

          navigate("/bussearch");
        }
      }
    }


  };
  return (
    <>
      <div className="px-5 lg:px-16 bg-[#e7f7fe] pt-2">
        <div className="flex    justify-between items-center ">
          <div className="ml-2 lg:ml-0 lg:w-[40%]">
            <p className="leading:1 text-2xl font-bold lg:text-6xl lg:leading-none text-[#37474f]">
              Find cheap bus tickets for your next trip
            </p>
            <p className="mt-2 text-sm lg:mt-8 text-[#607d8b] font-bold lg:text-lg">
              Easily compare and book your next trip with Busbud
            </p>
          </div>
          <img className="hidden lg:block" src={HEROIMG} alt="Hero Image" />
        </div>
        {error !== '' ? <p className="hidden lg:block text-red-500 pt-2  mt-8 text-center pb-1">{error}</p> : <></>}
        <div className="lg:flex lg:justify-center pb-10 lg:mr-10 ">
          <div className=" lg:flex lg:bg-white items-center overflow-hidden justify-between pl-2 lg:w-[95%] rounded-md ">
            <div className=" mt-9 lg:mt-0 px-2 py-2 lg:w-[30%] border border-white  rounded-md  hover:border-gray-200 mb-1 bg-white lg:mb-0 ">
              <p className="text-[0.6rem] text-[#757575] font-bold">ORIGIN</p>
              <input
                value={origin}
                placeholder="Leaving from"
                className="w-full border-none outline-none text-[#757575] text-base"
                onChange={handleQueryChange}
              />
            </div>
            <BsArrowLeftRight className="hidden lg:block h-5 w-5 cursor-pointer" onClick={() => toggleOriginandDest()} />
            <div className=" px-2 py-3 lg:w-[30%] border border-white  rounded-md  hover:border-gray-200 mb-1 bg-white lg:mb-0">
              <p className="text-[0.6rem] text-[#757575] font-bold">
                DESTINATION
              </p>
              <input
                value={destination}
                onChange={handleQuerytwoChange}
                placeholder="Going to"
                className="w-full border-none outline-none text-[#757575] text-base"
              />
            </div>
            <div
              onClick={() => setshowcalendar(!showcalendar)}
              className="px-2 py-3 lg:w-[30%] border border-white  rounded-md  hover:border-gray-200 mb-3 bg-white lg:mb-0  "
            >
              <p className="text-[0.6rem] text-[#757575] font-bold">Date</p>
              <input
                value={format(date, "eee, MMM dd")}
                placeholder="Going to"
                className="w-full border-none outline-none text-[#757575] text-base"
              />
            </div>

            <div className="bg-[#0091FF] lg:h-[100%] py-5 lg:py-2 text-white font-bold lg:text-lg text-center rounded-sm">
              <p
                className="px-6 cursor-pointer"
                onClick={() => handleSearchButton()}
              >
                Search Buses
              </p>
            </div>
            {error !== '' ? <p className=" lg:hidden text-red-500 pt-2  mt-8 text-center pb-1">{error}</p> : <></>}
          </div>

        </div>

      </div>
      <div className="flex ">
        {showoriginmenu ? (
          <ul className="absolute top-[16.5rem] left-10 lg:top-[29.8rem] lg:left-[5.7rem] px-2 py-1 h-[10rem] w-[20rem] border overflow-y-scroll  bg-white rounded-xl">
            {filteredCities.map((x) => (
              <li
                key={x._id}
                onClick={() => handleShowOrigin(x.City)}
                className="cursor-pointer hover:bg-[#e7f7fe] flex  mb-2 rounded-xl items-center px-2 gap-2"
              >
                <MdLocationPin />
                <span className=" py-1 font-semibold ">{x.City}</span>
                <span className=" py-1 text-xs text-gray-400">{x.State}</span>
              </li>
            ))}
          </ul>
        ) : (
          <></>
        )}
        {showdestinationmenu ? (
          <ul className="absolute top-[20.7rem] left-10  lg:top-[29.8rem] lg:left-[26rem] px-2 py-1 h-[10rem] w-[20rem] border overflow-y-scroll  bg-white rounded-xl   ">
            {filteredtwoCities.map((x) => (
              <li
                key={x._id}
                onClick={() => handleShowDestination(x.City)}
                className="cursor-pointer hover:bg-[#e7f7fe] flex  mb-2 rounded-xl items-center px-2 gap-2"
              >
                <MdLocationPin />
                <span className=" py-1 font-semibold ">{x.City}</span>
                <span className=" py-1 text-xs text-gray-400">{x.State}</span>
              </li>
            ))}
          </ul>
        ) : (
          <></>
        )}
        {showcalendar ? (
          <Calendar
            date={date}
            onChange={(date) => handleCalendarSelect(date)}
            className="absolute top-[25rem] left-7 lg:top-[29.8rem] lg:left-[46rem] rounded-md bg-[#fff]"
          />
        ) : (
          <></>
        )}

        <div className=" px-5 lg:flex gap-8 lg:px-28 bg-[#e7f7fe] pt-2 lg:items-center pb-12">
          <div className="flex gap-2 items-center mb-2 lg-mb-0">
            <img src={YOURTRIPLOGO} className="h-8 w-8 lg:h-12 lg:w-12" />
            <div>
              <p className="font-semibold text-sm">Your Trip, your priorities</p>
              <p className="text-xs lg:text-sm text-gray-400 mt-1">On a budget? Tight schedule? Book tickets that fit your needs.</p>
            </div>
          </div>
          <div className="flex gap-2 items-center mb-2 lg:mb-0">
            <img src={GLOBALLOGO} className="h-8 w-8 lg:h-12 lg:w-12" />
            <div>
              <p className="font-semibold text-sm">National coverage</p>
              <p className="text-xs lg:text-sm text-gray-400 mt-1">Save time by comparing all your bus travel options in one place.</p>
            </div>
          </div>
          <div className="flex gap-2 items-center mb-2 lg:mb-0">
            <img src={SUPPORTLOGO} className="h-8 w-8 lg:h-12 lg:w-12" />
            <div>
              <p className="font-semibold text-sm">24/7 support</p>
              <p className="text-xs lg:text-sm text-gray-400 mt-1">Our world class team of experts is always here to help.</p>
            </div>
          </div>
        </div>
      </div>
      <TravelBloggerHome />
      <TopTravelledRoutesComponent />
    </>
  );
};

export default HomePage;
